import keyBy from "lodash/keyBy";
import * as types from "../actions/actionTypes";
import intialState from "./initialState";

import { IGame } from "../../types/game/Game";
type GamesState = { [id: string]: IGame };

interface GamesPayload { games: IGame[] }

const handles: Record<string, Function> = {
  [types.SHIFTS_GET_SHIFT_FULFILLED]: (state: GamesState, { games }: GamesPayload) => ({
    ...state,
    ...keyBy(games, "_id"),
  }),
  [types.SHIFT_ROSTER_GAME_STARTED]: (state: GamesState, gameId: string) => ({
    ...state,
    [gameId]: {
      ...(state[gameId] || {}),
      loading: true,
      error: false,
    },
  }),
  [types.SHIFT_ROSTER_GAME_FULFILLED]: (state: GamesState, { games }: GamesPayload) => ({
    ...state,
    ...games.reduce((m: GamesState, game: IGame) => {
      m[game._id] = {
        ...(game as IGame),
        loading: false,
      } as IGame;
      return m;
    }, {} as GamesState),
  }),
  [types.SHIFT_ROSTER_GAME_REJECTED]: (state: GamesState, { message, gameId }: { message: string; gameId: string }) => ({
    ...state,
    [gameId]: {
      ...(state[gameId] || { _id: gameId }),
      message,
      loading: false,
    },
  }),
  [types.GAME_REMOVE_ERRORS]: (state: GamesState, gameId: string) => ({
    ...state,
    [gameId]: {
      ...(state[gameId] || { _id: gameId }),
      message: null,
      loading: false,
    },
  }),
  [types.GAMES_UPDATE_STARTED]: (state: GamesState, gameId: string) => ({
    ...state,
    [gameId]: {
      ...state[gameId],
      loading: true,
    },
  }),
  [types.GAMES_UPDATE_FULFILLED]: (state: GamesState, { games }: GamesPayload) => ({
    ...state,
    ...keyBy(games, "_id"),
  }),
  [types.GAMES_UPDATE_REJECTED]: (state: GamesState, { gameId, message }: { gameId: string; message: string }) => ({
    ...state,
    [gameId]: {
      ...(state[gameId] || { _id: gameId }),
      loading: false,
      message,
    },
  }),
  [types.GAMES_ADDED_EXTRA_OFFICIAL_STARTED]: (state: GamesState, gameId: string) => ({
    ...state,
    [gameId]: {
      ...state[gameId],
      loading: true,
    },
  }),
  [types.GAMES_ADDED_EXTRA_OFFICIAL_REJECTED]: (
    state: GamesState,
    { message, gameId }: { message: string; gameId: string },
  ) => ({
    ...state,
    [gameId]: {
      ...(state[gameId] || { _id: gameId }),
      message,
      loading: false,
    },
  }),

  [types.GAMES_ADDED_EXTRA_OFFICIAL_FULLFILLED]: (state: GamesState, game: IGame) => ({
    ...state,
    [game._id]: game,
  }),
  [types.GAMES_REMOVE_EXTRA_OFFICIAL_STARTED]: (state: GamesState, gameId: string) => ({
    ...state,
    [gameId]: {
      ...state[gameId],
      loading: true,
    },
  }),
  [types.GAMES_REMOVE_EXTRA_OFFICIAL_REJECTED]: (
    state: GamesState,
    { message, gameId }: { message: string; gameId: string },
  ) => ({
    ...state,
    [gameId]: {
      ...(state[gameId] || { _id: gameId }),
      message,
      loading: false,
    },
  }),

  [types.GAMES_REMOVE_EXTRA_OFFICIAL_FULLFILLED]: (state: GamesState, game: IGame) => ({
    ...state,
    [game._id]: game,
  }),
};

interface AnyAction { type: string; payload?: any }

export default function gameReducer(state: GamesState = intialState.games, action: AnyAction): GamesState {
  return action.type in handles
    ? (handles as any)[action.type](state, action.payload)
    : state;
}
